<template>
<b-container fluid class="container">
   <b-row class="justify-content-md-center">
          <b-col col md="3" class="text-center">
           <Descripcion/>
            <div class="mb-5" >
                  <img src="../assets/wizard2.png" class="img-fluid" alt="" />
            </div>
            <hr>
            <div class="mb-5">
              <h6>Estamos para ayudarte</h6>
              <p style="font-size: 15px">¿Deseas ser asistido por uno de nuestros asesores?</p>
                  <b-button @click.prevent="" variant="outline-primary" class="button_H11">ESTAMOS PARA AYUDARTE</b-button>
            </div>
          </b-col>
          <b-col  col md="9" class="card-body text-center">
            <b-col class="text-left" style="background-color: #DD3E23;">
              <p style="color: white; font-size: 20px">Registro de Usuario</p>
            </b-col>
            <h1 class="mt-5">Registra tus información.</h1>
            <h5 style="font-weight: bold;" class="mt-3">Genera un usuario para continuar con el proceso.</h5>
            <p>* Campos obligatorios para continuar con el proceso</p>

            <b-card border-variant="light" class="mt-3">
            <b-form @submit="onSubmit" @reset="onReset" v-if="show">
            <b-row >
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-1"  class="text-left" label-for="input-1">
                        <h6>Nombre(s):</h6>
                    <b-form-input id="input-1" type="text" class="inputFormulario" v-model="formaData.customerName" placeholder="Nombre(s)" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))" maxlength="26" required></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-2" class="text-left" label-for="input-3">
                        <h6>Primer Apellido:</h6>
                    <b-form-input id="input-2" class="inputFormulario" v-model="formaData.customerSurname" placeholder="Primer Apellido" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))" maxlength="26" required></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-3"  class="text-left" label-for="input-3">
                        <h6>Segundo Apellido:</h6>
                    <b-form-input id="input-3" class="inputFormulario" v-model="formaData.customerSurname2" placeholder="Segundo Apellido" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))" maxlength="26" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
            </b-row>
            <b-row class="mt-2">
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-5" label-for="input-5" class="text-left">
                        <h6>Email:</h6>
                        <b-form-input id="input-5"  v-model="formaData.customerEmail" type="email" placeholder="Ingresa tu email" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-6" class="text-left" label-for="input-6">
                        <h6>Teléfono:</h6>
                    <b-form-input id="input-6" class="inputFormulario" v-model="formaData.customerPhone" type="text" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" placeholder="Número de Teléfono" maxlength="10" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-3"  class="text-left" label-for="input-3">
                        <h6>Interes de Compra:</h6>
                    <b-form-input id="input-3" class="inputFormulario" placeholder="" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))" maxlength="26" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
            </b-row>

            <b-row class="mt-2">
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-12" class="text-left" label-for="input-12">
                        <h6>RFC:</h6>
                        <b-form-input id="input-12" class="inputFormulario" v-model="formaData.customerRfc" placeholder="RFC" maxlength="13" required pattern="[A-Z]{4}[0-9]{6}[A-Z0-9]{3}" title="El formato de RFC no es correcto"></b-form-input>
                        <b-form-text id="input-live-help">Tu RFC debe ser a 13 dígitos.</b-form-text>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-6">
                    <b-col>
                        <b-form-group id="input-group-11" class="text-left" label-for="input-11">
                            <h6>Régimen Fiscal:</h6>
                                <b-form-select id="input-11" v-model="formaData.regimen" :options="regimen" class="mb-2 selectF" required></b-form-select>
                        </b-form-group>
                    </b-col>
                </div>
            </b-row>

            <b-row class="mt-5">
                <div class="col-md-6 text-left">
                <b-col>
                  <h6>Contraseña:</h6>
                  <div class="input-group mb-3">
                    <input type="password" id="password" v-model="formaData.password" class="inputFormulario" placeholder="  Contraseña">
                    <b-button @click.prevent="mostrarContrasena()" class="button_pass"><b-icon icon="eye" aria-hidden="true"></b-icon></b-button>  
                  </div>
                </b-col>
                </div>
            </b-row>

            <b-row class="mt-5">
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-7" class="text-left" label-for="input-7">
                        <h6>Código Postal:</h6>
                    <b-form-input id="input-7" class="inputFormulario" v-model="formaData.customerAddressZipcode" placeholder="Código Postal" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" maxlength="5" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-8" label-for="input-8" class="text-left">
                        <h6>Estado:</h6>
                        <b-form-input id="input-8" class="inputFormulario" v-model="formaData.customerAddressState" placeholder="Estado" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))" maxlength="40" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>

                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-9" class="text-left" label-for="input-9">
                        <h6>Ciudad:</h6>
                    <b-form-input id="input-9" class="inputFormulario" v-model="formaData.customerAddressCity" placeholder="Ciudad" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))" maxlength="40" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
            </b-row>

            <b-row>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-16" class="text-left" label-for="input-16">
                        <h6>Colonia o Población:</h6>
                    <b-form-input id="input-16" class="inputFormulario" v-model="formaData.customerAddress2" placeholder="Colonia" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))" maxlength="40" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-17" class="text-left" label-for="input-17">
                        <h6>Delegación o Municipio:</h6>
                    <b-form-input id="input-17" class="inputFormulario" placeholder="Delegación" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))" maxlength="40" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-13" class="text-left" label-for="input-13">
                        <h6>Calle:</h6>
                    <b-form-input id="input-13" class="inputFormulario" v-model="formaData.customerAddress" placeholder="Calle" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))" maxlength="40" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
            </b-row>
            <b-row class="mt-2">
            <div class="col-md-3">
                <b-col>
                    <b-form-group id="input-group-14" label-for="input-14" class="text-left">
                        <h6>Número Exterior:</h6>
                        <b-form-input id="input-14" class="inputFormulario" v-model="formaData.customerAddressNumExt" type="text" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" maxlength="5" placeholder="Exterior" required></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-3">
                <b-col>
                    <b-form-group id="input-group-15" class="text-left" label-for="input-15">
                        <h6>Número Interior:</h6>
                    <b-form-input id="input-15" class="inputFormulario" v-model="formaData.customerAddressNumInt" type="text" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" maxlength="5" placeholder="Interior"  ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
            </b-row>

            <b-row v-if="this.error == true" align-h="center" class="justify-content-md-center m-auto">
              <b-col md="6" lg="6" sm="6" class="mt-2 rounded">
                <b-alert show class="mensajev" variant="danger" >{{this.merror}}</b-alert>
              </b-col>
            </b-row>

            <b-row v-if="this.errorService == true" align-h="center" class="justify-content-md-center m-auto">
              <b-col md="6" lg="6" sm="6" class="mt-2 rounded">
                <b-alert show variant="danger" >Error Service</b-alert>
              </b-col>
            </b-row>

            <b-row class="mt-3">
                <div class="col-md-12">
                <b-col>
                  <b-button type="submit" variant="primary" class="button_H">CREAR USUARIO</b-button>
                  <b-button @click.prevent="regresar()" variant="primary" class="button_H1">REGRESAR</b-button>
                </b-col>
                </div>
            </b-row>

      <!-- <b-card class="mt-3" header="JSON">
        <pre class="m-0">{{ this.formaData }}</pre>
      </b-card> -->

      <b-row align-h="center" >
        <div class="col-md-9">
        <b-col>        
          <b-form-checkbox id="checkbox-2" v-model="terminos" name="checkbox-2" value="accepted" unchecked-value="not_accepted">
            <a href="https://www.autocom.mx/formato-derechos-arco.html" target="_blank" style="color: #DD3E23">Términos y condiciones</a>
          </b-form-checkbox>
        </b-col>
        </div>
      </b-row>
      <b-row align-h="center" >
        <div class="col-md-9">
        <b-col>          
          <b-form-checkbox id="checkbox-1" v-model="privacidad" name="checkbox-1" value="accepted" unchecked-value="not_accepted">
            <a href="https://www.autocom.mx/aviso-de-privacidad.html" target="_blank" style="color: #DD3E23" >Aviso de privacidad</a>
          </b-form-checkbox>
        </b-col>
        </div>        
      </b-row>
            <div><p class="aviso mt-3">En cumplimiento a lo previsto en la Ley General de Protección de Datos Personales en Posesión de Sujetos Obligados, nos permitimos informarle lo siguiente:
                Nissan Autocom Morelia Madero, en lo sucesivo ("Nissan Autocom Morelia Madero"), con domicilio en Av. Madero Pte. 1613 Col. Gertrudis Bocanegra., Morelia, Michoacán de Ocampo, Mexico 58150, es responsable de recabar sus datos personales, del tratamiento que se les da a los mismos y de su adecuada protección, para sí o para cualquiera de las sociedades mercantiles que sean sus subsidiarias o filiales.</p></div>
            </b-form>
        </b-card>

          </b-col>
    </b-row>
</b-container>
</template>

<script>
import Descripcion from './Descripcion.vue';

export default {
  name: 'Registro',

  components: {
    Descripcion
  },

    data() {
    return {
      error: false,
      errorService: false,
      merror:'',
      contents: null,
      monto: sessionStorage.getItem("montoWeb"),
      privacidad: 'not_accepted',
      terminos: 'not_accepted',
          formaData: {
            customerName: '',
            customerSurname: '',
            customerSurname2: '',
            customerEmail: '',
            customerPhone: '',
            password: '',
            app: 'Reservas',
            customerPhoneMobile: this.customerPhone,
            customerRfc: '',
            customerAddress: '',
            customerAddress2: '',
            customerAddressCity: '',
            customerAddressState: '',
            customerAddressCountry: 'México',
            customerAddressZipcode: '',
            customerAddressNumInt: '',
            customerAddressNumExt: '',
            type: true
          },
        show: true,
        regimen: [
          { value: 'Fisica', text: 'Persona Física' },
          { value: 'Fisica AE', text: 'Persona Física con Actividad Empresarial' }
        ],

      };
  },

  methods: {
        onSubmit(event) {
            event.preventDefault();
            this.tokenUser();
            sessionStorage.setItem("mail", this.formaData.customerEmail);
            sessionStorage.setItem("telefono", this.formaData.customerPhone);
            sessionStorage.setItem("nombre", this.formaData.customerName);
            sessionStorage.setItem("materno", this.formaData.customerSurname);
            sessionStorage.setItem("paterno", this.formaData.customerSurname2);
            //sessionStorage.setItem("user", this.formaData.customerName+' '+this.formaData.customerSurname+' '+this.formaData.customerSurname2);
            //sessionStorage.setItem("pass", this.formaData.password);
            //  this.generaCodigo();
            //  this.$router.push({ path: '/CodigoVerificacion'});
        },

        onReset(event) {
            window.history.go(-2);
        },

        // reserva(){
        //   this.$router.push({ path: '/Codigo'});
        // },

      //  generaCodigo() {
      //    this.codigoReserva = Math.floor(100000 + Math.random() * 900000);
      //    sessionStorage.setItem("codigoReserva", this.codigoReserva); 
      //    return this.codigo;
      //  },

    tokenUser(){
       let userTk = {
       username: "marco.villegas@autocom.mx",
       //password: "B8jc8q!n"}; //qa
       password: "Asd12345"}; //prod
       axios.post("https://qasrv-login.autocom.mx/api/Token/login", userTk)
        .then((response) => {
          this.contents = response.data.token;
          sessionStorage.setItem("tknUser", response.data.token);
          this.createUser();
        });
    },
    createUser(){
        let user = {
            customerName: this.formaData.customerName,
            customerSurname: this.formaData.customerSurname,
            customerSurname2: this.formaData.customerSurname2,
            customerEmail: this.formaData.customerEmail,
            customerPhone: this.formaData.customerPhone,
            password: this.formaData.password,
            app: 'Reservas',
            customerPhoneMobile: this.formaData.customerPhoneMobile,
            customerRfc: this.formaData.customerRfc,
            customerAddress: this.formaData.customerAddress,
            customerAddress2: this.formaData.customerAddress2,
            customerAddressCity: this.formaData.customerAddressCity,
            customerAddressState: this.formaData.customerAddressState,
            customerAddressCountry: 'México',
            customerAddressZipcode: this.formaData.customerAddressZipcode,
            customerAddressNumInt: this.formaData.customerAddressNumInt,
            customerAddressNumExt: this.formaData.customerAddressNumExt,
            type: true
        }

          axios.post('https://qasrv-login.autocom.mx/api/Customer/CreateCustomer', user,  {
            headers: {
            Authorization: "Bearer " + sessionStorage.getItem("tknUser"),
            'Content-Type': 'application/json',
            }, 
            }).then(response =>{
              this.registro = response.data.status;
              if (this.registro == 'success'){
                sessionStorage.setItem("loginAct", this.registro);
                this.$router.push({ path: '/CodigoVerificacion'});
              } else {
                this.error = true;
                this.merror = response.data.message;
              }
          }).catch(error=>{
          this.errorService = true;
          console.log(error)
          })
    },

    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    formatPriceCostos(value) {
        let val = (value/1).toFixed(2).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    mostrarContrasena(){
          var tipo = document.getElementById("password");
          if(tipo.type == "password"){
              tipo.type = "text";
          }else{
              tipo.type = "password";
          }
      },

    regresar(){
      window.history.go(-1);
    }
  },
  
  created() {

  },

     computed: {
      validaRfc() {
        return this.formaData.AditionalInfo.RFC.length < 14 && this.formaData.AditionalInfo.RFC.length > 12 && this.formaData.AditionalInfo.RFC.length != '' ? true: false
      },

      validaTel() {
        return this.formaData.PhoneNumber.length < 11 && this.formaData.PhoneNumber.length > 9 && this.formaData.PhoneNumber.length != '' ? true: false
      },

      validaCp() {
        return this.formaData.CodigoPostal.length < 6 && this.formaData.CodigoPostal.length > 4 && this.formaData.CodigoPostal.length != '' ? true: false
      },

      validaNombre() {
        return this.formaData.Nombre.length < 27 && this.formaData.Nombre.length > 0 && this.formaData.Nombre.length != '' ? true: false
      },

      validaApaterno() {
        return this.formaData.ApellidoPaterno.length < 27 && this.formaData.ApellidoPaterno.length > 0 && this.formaData.ApellidoPaterno.length != '' ? true: false
      },

      validaAmaterno() {
        return this.formaData.ApellidoMaterno.length < 27 && this.formaData.ApellidoMaterno.length > 0 && this.formaData.ApellidoMaterno.length != '' ? true: false
      },

      validaCalle() {
        return this.formaData.AditionalInfo.Calle.length < 41 && this.formaData.AditionalInfo.Calle.length > 0 && this.formaData.AditionalInfo.Calle.length != '' ? true: false
      },
      validaEstado() {
        return this.form.estado.length < 41 && this.form.estado.length > 0 && this.form.estado.length != '' ? true: false
      },
      validaCiudad() {
        return this.formaData.CiudadNacimiento.length < 41 && this.formaData.CiudadNacimiento.length > 0 && this.formaData.CiudadNacimiento.length != '' ? true: false
      },
      validaDelegacion() {
        return this.form.delegacion.length < 41 && this.form.delegacion.length > 0 && this.form.delegacion.length != '' ? true: false
      },
      validaColonia() {
        return this.formaData.AditionalInfo.Colonia.length < 41 && this.formaData.AditionalInfo.Colonia.length > 0  && this.formaData.AditionalInfo.Colonia.length != '' ? true: false
      },
    }
}
</script>

<style scoped>


</style>